import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";
import { NFLookupDocument } from "./NFLookupDocument";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  index?: number;
  onValueChanged?: (e: any, index: number) => void;
  value?: any;
  tableName?: string;
  tableFieldName?: string;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupSalesOrders = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  value,
  onValueChanged,
  index,
  tableFieldName,
  tableName,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.SalesOrders.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupDocument
        fieldName={fieldName}
        title={title}
        entity={AppEntities.SalesOrders}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        value={value}
        onValueChanged={onValueChanged}
        index={index}
        tableFieldName={tableFieldName}
        tableName={tableName}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        {/* <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} /> */}
        <NFLookupCatalogColumn
          fieldName={"documentNumber"}
          caption={"documentNumber"}
        />
      </NFLookupDocument>
    </>
  );
};
